import React from 'react';

import { Stack, Typography } from '@gogame/components';
import { NumberValueFormatter, NumberRangeFormatter } from '@gogame/intl-ts';

export default ({ value }) => {
  if (!value) return null;

  return (
    <Stack direction={'row'}>
      {Array.isArray(value) ? (
        <React.Fragment>
          <Typography>
            <NumberRangeFormatter.Decimal value={value} />
          </Typography>
          <Typography>&nbsp;{value.length > 1 ? 'days' : 'day'}</Typography>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Typography>
            <NumberValueFormatter.Decimal value={value} />
          </Typography>
          <Typography>&nbsp;day</Typography>
        </React.Fragment>
      )}
    </Stack>
  );
};
